(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["air-before-after"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('felysia-before-after')) {
  customElements.define('felysia-before-after', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const opt = { signal: this.controller.signal };
      this.range = this.querySelector('input[type="range"]');
      this.stage = this.querySelector('.ba__stage, .fel-ba__stage');
      if (!this.range || !this.stage) return;
      this.range.disabled = false;
      this.setAttribute('data-ready', '');
      const set = (v) => {
        this.range.value = v;
        this.style.setProperty('--reveal', v + '%');
        this.dataset.pos = v < 18 ? 'low' : v > 82 ? 'high' : '';
        this.range.setAttribute('aria-valuetext', v + ' %');
      };
      const pos = (e) => { const b = this.stage.getBoundingClientRect(); set(Math.round(Math.max(0, Math.min(100, (e.clientX - b.left) / b.width * 100)))); };
      this.range.addEventListener('input', () => { this.touched = true; set(+this.range.value); }, opt);
      this.range.addEventListener('pointerdown', (e) => {
        if (!e.isPrimary || e.button !== 0) return;
        e.preventDefault(); this.touched = true;
        this.range.focus({ preventScroll: true });
        this.pointer = e.pointerId; this.range.setPointerCapture(e.pointerId); pos(e);
      }, opt);
      this.range.addEventListener('pointermove', (e) => { if (this.pointer === e.pointerId) pos(e); }, opt);
      const end = () => { this.pointer = null; };
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach((t) => this.range.addEventListener(t, end, opt));
      set(50);
      /* Petite démonstration au premier affichage pour montrer que l'image se compare */
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;
          this.io.disconnect();
          const keys = [[0, 50], [700, 22], [1500, 78], [2200, 50]];
          const t0 = performance.now();
          const step = (t) => {
            if (this.touched) return;
            const el = t - t0;
            let i = 0; while (i < keys.length - 1 && el > keys[i + 1][0]) i++;
            if (i >= keys.length - 1) { set(50); return; }
            const [ta, va] = keys[i], [tb, vb] = keys[i + 1];
            const k = (el - ta) / (tb - ta), e = k < .5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
            set(Math.round(va + (vb - va) * e));
            requestAnimationFrame(step);
          };
          setTimeout(() => requestAnimationFrame(step), 400);
        }, { threshold: 0.6 });
        this.io.observe(this);
      }
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null; this.pointer = null; this.io?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["air-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('air-reviews')) {
    customElements.define('air-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return; this.ready = true;
        const track = this.querySelector('.rv__track');
        const ctrl = this.querySelector('.rv__ctrl');
        if (!track) return;
        const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.querySelectorAll('.rv__qw').forEach((w) => {
          const q = w.querySelector('.rv__q'), b = w.querySelector('.rv__more');
          if (!q || !b) return;
          requestAnimationFrame(() => { if (q.scrollHeight > q.clientHeight + 2) b.hidden = false; });
          b.addEventListener('click', () => { const o = w.classList.toggle('is-open'); b.setAttribute('aria-expanded', o); b.textContent = o ? 'Réduire' : 'Lire la suite'; });
        });
        const prev = this.querySelector('.rv__btn--prev'), next = this.querySelector('.rv__btn--next');
        const bar = ctrl && ctrl.querySelector('.rv__bar');
        const step = () => { const c = track.querySelector('.rv__card'); return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 20) : track.clientWidth; };
        const update = () => {
          const max = track.scrollWidth - track.clientWidth;
          const has = max > 4;
          if (ctrl) ctrl.hidden = !has;
          if (prev) prev.hidden = !has;
          if (next) next.hidden = !has;
          if (!has || !prev || !next) return;
          prev.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= max - 2;
          const w = Math.max(12, track.clientWidth / track.scrollWidth * 100);
          bar.style.setProperty('--w', w + '%');
          bar.style.setProperty('--x', (track.scrollLeft / max) * (100 - w) + '%');
        };
        const go = (dir) => {
          const max = track.scrollWidth - track.clientWidth;
          if (dir > 0 && track.scrollLeft >= max - 2) { track.scrollTo({ left: 0, behavior: reduce ? 'auto' : 'smooth' }); return; }
          track.scrollBy({ left: step() * dir, behavior: reduce ? 'auto' : 'smooth' });
        };
        [prev, next].forEach((b) => b && b.addEventListener('click', () => { go(Number(b.dataset.dir)); this.stop(); }));
        track.addEventListener('scroll', update, { passive: true });
        this.ro = new ResizeObserver(update); this.ro.observe(track); update();
        if (this.dataset.auto === 'true' && !reduce) {
          let hover = false, visible = false;
          this.stop = () => { clearInterval(this.t); this.t = null; };
          const start = () => { if (!this.t) this.t = setInterval(() => { if (!hover && visible && !document.hidden) go(1); }, 4500); };
          this.addEventListener('pointerenter', () => { hover = true; });
          this.addEventListener('pointerleave', () => { hover = false; });
          track.addEventListener('touchstart', () => this.stop(), { passive: true });
          track.addEventListener('focusin', () => this.stop());
          this.io = new IntersectionObserver(([e]) => { visible = e.isIntersecting; }); this.io.observe(this);
          start();
        } else { this.stop = () => {}; }
      }
      disconnectedCallback() { this.ro && this.ro.disconnect(); this.io && this.io.disconnect(); this.stop && this.stop(); this.ready = false; }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
